import { render } from "./SuccessPayment.vue?vue&type=template&id=4c52fd22&scoped=true&ts=true"
import script from "./SuccessPayment.vue?vue&type=script&lang=ts"
export * from "./SuccessPayment.vue?vue&type=script&lang=ts"

import "./SuccessPayment.vue?vue&type=style&index=0&id=4c52fd22&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c52fd22"]])

export default __exports__